(function () {
  'use strict';

  var HEADER_SELECTORS = [
    '.announcement-bar-section',
    '.utility-bar',
    '.shopify-section-group-header-group',
    '#shopify-section-header',
    'sticky-header',
    '.header-wrapper',
    'header.header',
    '.section-header',
    '.header',
    '.header-group',
    '#header-group'
  ];

  function getHeaderHeight() {
    var total = 0;
    var headerGroup = document.querySelector('.shopify-section-group-header-group, .header-group, #header-group');

    if (headerGroup) {
      return Math.ceil(headerGroup.getBoundingClientRect().height);
    }

    HEADER_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.top < 20) {
          total = Math.max(total, Math.ceil(rect.bottom));
        }
      });
    });

    return total || 80;
  }

  function updateLayoutOffsets() {
    var height = getHeaderHeight();
    document.documentElement.style.setProperty('--ug-header-height', height + 'px');
    document.querySelectorAll('.ug-event').forEach(function (section) {
      section.style.setProperty('--ug-header-height', height + 'px');
    });
  }

  function initHeroSlider(root) {
    if (root.dataset.ugInit === 'true') return;
    root.dataset.ugInit = 'true';

    var track = root.querySelector('[data-ug-track]');
    var slides = root.querySelectorAll('[data-ug-slide]');
    var prevBtn = root.querySelector('[data-ug-prev]');
    var nextBtn = root.querySelector('[data-ug-next]');
    var dots = root.querySelectorAll('[data-ug-dot]');
    if (!track || slides.length === 0) return;

    var index = 0;
    var total = slides.length;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval || '6000', 10);
    var timer;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, d) {
        dot.classList.toggle('is-active', d === index);
        dot.setAttribute('aria-selected', d === index ? 'true' : 'false');
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot, d) {
      dot.addEventListener('click', function () { goTo(d); });
    });

    if (autoplay && total > 1) {
      timer = setInterval(function () { goTo(index + 1); }, interval);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', function () {
        timer = setInterval(function () { goTo(index + 1); }, interval);
      });
    }

    goTo(0);
  }

  function initSidebarSticky() {
    document.querySelectorAll('.ug-lux-page-layout').forEach(function (layout) {
      var sidebar = layout.querySelector('.ug-lux-page-sidebar');
      var card = sidebar && sidebar.querySelector('.ug-lux-ticket, .ug-lux-concierge-card');
      if (!sidebar || !card) return;

      if (sidebar.dataset.ugInit === 'true') return;
      sidebar.dataset.ugInit = 'true';

      function resetFallback() {
        card.style.position = '';
        card.style.top = '';
        card.style.left = '';
        card.style.width = '';
        sidebar.style.minHeight = '';
        sidebar.style.position = '';
      }

      function cssStickyBroken() {
        if (window.innerWidth <= 768) return false;

        var headerOffset = getHeaderHeight() + 24;
        var layoutRect = layout.getBoundingClientRect();
        var sidebarRect = sidebar.getBoundingClientRect();

        return layoutRect.top < headerOffset && sidebarRect.top > headerOffset + 12;
      }

      function applyFallback() {
        if (window.innerWidth <= 768) {
          resetFallback();
          return;
        }

        if (!cssStickyBroken()) {
          resetFallback();
          return;
        }

        var headerOffset = getHeaderHeight() + 24;
        var layoutRect = layout.getBoundingClientRect();
        var sidebarRect = sidebar.getBoundingClientRect();
        var cardHeight = card.offsetHeight;
        var layoutBottom = layoutRect.bottom;

        sidebar.style.minHeight = cardHeight + 'px';
        sidebar.style.position = 'relative';

        if (layoutBottom <= headerOffset + cardHeight) {
          card.style.position = 'absolute';
          card.style.top = (layout.offsetHeight - cardHeight) + 'px';
          card.style.left = '0';
          card.style.width = '100%';
          return;
        }

        card.style.position = 'fixed';
        card.style.top = headerOffset + 'px';
        card.style.left = sidebarRect.left + 'px';
        card.style.width = sidebarRect.width + 'px';
      }

      window.addEventListener('scroll', applyFallback, { passive: true });
      window.addEventListener('resize', function () {
        updateLayoutOffsets();
        applyFallback();
      });
      applyFallback();
    });
  }

  function initFaq(root) {
    if (root.dataset.ugInit === 'true') return;
    root.dataset.ugInit = 'true';

    root.querySelectorAll('[data-ug-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-ug-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        if (root.dataset.accordion === 'single') {
          root.querySelectorAll('[data-ug-faq-item]').forEach(function (other) {
            if (other !== item) other.classList.remove('is-open');
          });
        }
        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  function initQty(root) {
    if (root.dataset.ugInit === 'true') return;
    root.dataset.ugInit = 'true';

    var minus = root.querySelector('[data-ug-qty-minus]');
    var plus = root.querySelector('[data-ug-qty-plus]');
    var input = root.querySelector('[data-ug-qty-input]');
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '10', 10);

    function update(val) {
      input.value = String(Math.max(min, Math.min(max, val)));
    }

    if (minus) minus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      update(parseInt(input.value, 10) - 1);
    });

    if (plus) plus.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      update(parseInt(input.value, 10) + 1);
    });
  }

  function initCountdown(root) {
    if (root.dataset.ugInit === 'true') return;
    root.dataset.ugInit = 'true';

    var target = root.dataset.target;
    if (!target) return;

    var end = new Date(target).getTime();
    var els = {
      days: root.querySelector('[data-ug-days]'),
      hours: root.querySelector('[data-ug-hours]'),
      mins: root.querySelector('[data-ug-mins]'),
      secs: root.querySelector('[data-ug-secs]')
    };

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);

      if (els.days) els.days.textContent = String(d);
      if (els.hours) els.hours.textContent = String(h).padStart(2, '0');
      if (els.mins) els.mins.textContent = String(m).padStart(2, '0');
      if (els.secs) els.secs.textContent = String(s).padStart(2, '0');

      if (diff > 0) setTimeout(tick, 1000);
    }

    tick();
  }

  function initGSAP() {
    if (typeof gsap === 'undefined') return;

    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    gsap.utils.toArray('.ug-reveal').forEach(function (el) {
      if (el.closest('.ug-lux-page-sidebar')) return;
      if (el.closest('.ug-lux-concierge-card')) return;
      if (el.closest('[data-ug-modal]')) return;
      gsap.fromTo(el,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 88%',
            toggleActions: 'play none none none'
          }
        }
      );
    });

    gsap.utils.toArray('.ug-lux-feature-card').forEach(function (card, i) {
      gsap.fromTo(card,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.7,
          delay: i * 0.06,
          ease: 'power2.out',
          scrollTrigger: { trigger: card, start: 'top 92%' }
        }
      );
    });

    gsap.utils.toArray('.ug-lux-hero__particle').forEach(function (p, i) {
      gsap.to(p, {
        y: '+=40',
        x: '+=20',
        duration: 3 + i * 0.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    });
  }

  var contactModalsReady = false;
  var openModals = [];
  var savedScrollY = 0;

  function getViewportHeight() {
    if (window.visualViewport && window.visualViewport.height) {
      return window.visualViewport.height;
    }
    return window.innerHeight;
  }

  function setModalSheetHeight(modal) {
    var sheet = modal.querySelector('.ug-lux-modal__sheet');
    if (!sheet) return;

    if (window.innerWidth <= 768) {
      var height = Math.round(getViewportHeight() * 0.92);
      modal.style.setProperty('--ug-modal-sheet-height', height + 'px');
      sheet.style.height = height + 'px';
    } else {
      modal.style.removeProperty('--ug-modal-sheet-height');
      sheet.style.height = '';
    }
  }

  function lockBodyScroll() {
    savedScrollY = window.scrollY || window.pageYOffset;
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.classList.add('ug-modal-open');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('ug-modal-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }

  function portalModals() {
    document.querySelectorAll('[data-ug-modal]').forEach(function (modal) {
      if (modal.dataset.ugPortalized === 'true') return;
      document.body.appendChild(modal);
      modal.dataset.ugPortalized = 'true';
    });
  }

  function openModal(modal, trigger) {
    if (!modal || modal.classList.contains('is-open')) return;

    var heading = trigger && trigger.getAttribute('data-ug-modal-heading');
    var eyebrow = trigger && trigger.getAttribute('data-ug-modal-eyebrow');
    var description = trigger && trigger.getAttribute('data-ug-modal-description');
    var interest = trigger && trigger.getAttribute('data-ug-modal-interest');
    var submitLabel = trigger && trigger.getAttribute('data-ug-modal-submit');

    var headingEl = modal.querySelector('[data-ug-modal-heading]');
    var eyebrowEl = modal.querySelector('[data-ug-modal-eyebrow]');
    var descriptionEl = modal.querySelector('[data-ug-modal-description]');
    var submitEl = modal.querySelector('[data-ug-modal-submit]');
    var interestSelect = modal.querySelector('[data-ug-modal-interest-select]');

    if (headingEl && heading) headingEl.textContent = heading;
    if (eyebrowEl && eyebrow) eyebrowEl.textContent = eyebrow;
    if (descriptionEl && description) {
      descriptionEl.textContent = description;
      descriptionEl.hidden = false;
    }
    if (submitEl && submitLabel) submitEl.textContent = submitLabel;
    if (interestSelect && interest) interestSelect.value = interest;

    setModalSheetHeight(modal);
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    lockBodyScroll();
    openModals.push(modal);

    var focusable = modal.querySelector('input:not([type="hidden"]):not([readonly]), select, textarea, button[type="submit"]');
    if (focusable && window.innerWidth > 768) {
      window.setTimeout(function () { focusable.focus(); }, 120);
    }
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('hidden', '');

    var sheet = modal.querySelector('.ug-lux-modal__sheet');
    if (sheet) sheet.style.height = '';
    modal.style.removeProperty('--ug-modal-sheet-height');

    openModals = openModals.filter(function (item) { return item !== modal; });
    if (!openModals.length) {
      unlockBodyScroll();
    }
  }

  function closeAllModals() {
    document.querySelectorAll('[data-ug-modal].is-open').forEach(closeModal);
  }

  function initContactModals() {
    portalModals();

    if (!contactModalsReady) {
      contactModalsReady = true;

      document.addEventListener('click', function (event) {
        var openTrigger = event.target.closest('[data-ug-modal-open]');
        if (openTrigger) {
          event.preventDefault();
          var modalId = openTrigger.getAttribute('data-ug-modal-open');
          var modal = document.getElementById(modalId);
          if (!modal) return;
          openModal(modal, openTrigger);
          return;
        }

        if (event.target.closest('[data-ug-modal-close]')) {
          var activeModal = event.target.closest('[data-ug-modal]');
          closeModal(activeModal);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAllModals();
      });

      document.addEventListener('focusin', function (event) {
        var field = event.target;
        if (!field.matches('input, select, textarea')) return;

        var scrollArea = field.closest('[data-ug-modal-scroll]');
        if (!scrollArea) return;

        window.setTimeout(function () {
          field.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 350);
      });

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', function () {
          openModals.forEach(setModalSheetHeight);
        });
      }

      window.addEventListener('resize', function () {
        openModals.forEach(setModalSheetHeight);
      });

      document.querySelectorAll('[data-ug-modal] form').forEach(function (form) {
        form.addEventListener('submit', function () {
          var combinedName = form.querySelector('[data-ug-combined-name]');
          if (!combinedName) return;

          var parts = form.querySelectorAll('[data-ug-name-part]');
          var fullName = Array.prototype.map.call(parts, function (input) {
            return input.value.trim();
          }).filter(Boolean).join(' ');

          combinedName.value = fullName;
        });
      });
    }

    document.querySelectorAll('[data-ug-modal]').forEach(function (modal) {
      if (modal.querySelector('.ug-lux-form__success')) {
        openModal(modal);
      }
    });
  }

  function initEventPromoPopup() {
    var popup = document.querySelector('[data-ug-event-promo]');
    if (!popup || popup.dataset.ugPromoInit === 'true') return;
    popup.dataset.ugPromoInit = 'true';

    var storageKey = popup.getAttribute('data-storage-key') || 'ug-bloom-promo-dismissed';
    var promoLink = popup.getAttribute('data-promo-link') || '/pages/bloom-glow';
    var hideOnBloom = popup.getAttribute('data-hide-on-bloom') === 'true';
    var showDelay = parseInt(popup.getAttribute('data-show-delay') || '800', 10);
    var templateSuffix = popup.getAttribute('data-current-template') || '';
    var pageHandle = popup.getAttribute('data-page-handle') || '';

    if (localStorage.getItem(storageKey) === 'true') return;

    if (hideOnBloom) {
      var onBloomPage = templateSuffix === 'bloom-and-glow'
        || pageHandle.indexOf('bloom') !== -1
        || window.location.pathname.indexOf('bloom-glow') !== -1
        || window.location.pathname.indexOf('bloom-and-glow') !== -1;
      if (onBloomPage) return;
    }

    function dismissPromo() {
      try {
        localStorage.setItem(storageKey, 'true');
      } catch (e) {}
      closePromo();
    }

    function openPromo() {
      document.body.appendChild(popup);
      popup.removeAttribute('hidden');
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('is-open');
      document.body.classList.add('ug-promo-open');
    }

    function closePromo() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('hidden', '');
      document.body.classList.remove('ug-promo-open');
    }

    popup.addEventListener('click', function (event) {
      if (event.target.closest('[data-ug-promo-close]')) {
        event.preventDefault();
        dismissPromo();
        return;
      }

      if (event.target.closest('[data-ug-promo-link]')) {
        dismissPromo();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        dismissPromo();
      }
    });

    window.setTimeout(openPromo, showDelay);
  }

  function initTicketScroll() {
    document.querySelectorAll('[data-ug-scroll-ticket]').forEach(function (link) {
      if (link.dataset.ugInit === 'true') return;
      link.dataset.ugInit = 'true';

      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        var offset = getHeaderHeight() + 24;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function init() {
    updateLayoutOffsets();
    document.querySelectorAll('[data-ug-hero]').forEach(initHeroSlider);
    document.querySelectorAll('[data-ug-faq]').forEach(initFaq);
    document.querySelectorAll('[data-ug-qty]').forEach(initQty);
    document.querySelectorAll('[data-ug-countdown]').forEach(initCountdown);
    initSidebarSticky();
    initTicketScroll();
    initContactModals();
    initEventPromoPopup();
    initGSAP();
  }

  function boot() {
    init();

    if (typeof gsap === 'undefined') {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
      s.onload = function () {
        var st = document.createElement('script');
        st.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
        st.onload = initGSAP;
        document.head.appendChild(st);
      };
      document.head.appendChild(s);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', updateLayoutOffsets);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function () {
    document.querySelectorAll('[data-ug-init]').forEach(function (el) {
      delete el.dataset.ugInit;
    });
  });
})();
